import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Share2, Mail } from 'lucide-react';

const Footer = () => (
  <footer className="bg-surface-container-low dark:bg-slate-900 border-t border-outline-variant/10 dark:border-slate-800 mt-auto">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="text-lg font-headline font-bold text-on-surface dark:text-white mb-4">Soccer Hub</div>
          <p className="text-on-surface-variant dark:text-slate-400 text-sm leading-relaxed">
            Plan your 2026 FIFA World Cup trip—host cities, stadiums, matches, and fan meetups in one place.
          </p>
          <div className="flex gap-4 mt-6 text-on-surface-variant dark:text-slate-500">
            <a href="https://worldcupfanplanner.com" className="hover:text-primary dark:hover:text-primary-container transition-transform hover:-translate-y-0.5" aria-label="Website">
              <Globe className="h-5 w-5" />
            </a>
            <span className="hover:text-primary dark:hover:text-primary-container cursor-default" aria-hidden>
              <Share2 className="h-5 w-5" />
            </span>
            <Link to="/contact" className="hover:text-primary dark:hover:text-primary-container transition-transform hover:-translate-y-0.5" aria-label="Contact">
              <Mail className="h-5 w-5" />
            </Link>
          </div>
        </div>
        <div>
          <h4 className="font-bold text-on-surface dark:text-white mb-4 uppercase text-xs tracking-widest">Planning</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/cities" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Host Cities
              </Link>
            </li>
            <li>
              <Link to="/tickets" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Match Tickets
              </Link>
            </li>
            <li>
              <Link to="/hotels" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Travel Partners
              </Link>
            </li>
            <li>
              <Link to="/fan-meetups" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Fan Meetups
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-on-surface dark:text-white mb-4 uppercase text-xs tracking-widest">About</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/about" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Cookie Policy
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-on-surface-variant hover:text-tertiary dark:text-slate-400 dark:hover:text-tertiary transition-colors">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-on-surface dark:text-white mb-4 uppercase text-xs tracking-widest">Newsletter</h4>
          <p className="text-on-surface-variant dark:text-slate-400 text-xs mb-4">Get match reminders and travel tips (coming soon).</p>
          <div className="flex rounded-lg overflow-hidden shadow-sm">
            <input
              type="email"
              placeholder="Your email"
              className="bg-surface-container-lowest dark:bg-slate-800 border-none text-sm px-3 py-2 flex-1 min-w-0 focus:ring-1 focus:ring-primary text-on-surface dark:text-slate-200"
              disabled
              aria-label="Newsletter email"
            />
            <button
              type="button"
              className="bg-primary text-on-primary px-3 py-2 flex items-center justify-center shrink-0 opacity-60 cursor-not-allowed"
              disabled
              aria-label="Subscribe"
            >
              <Mail className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-outline-variant/20 dark:border-slate-700">
        <p className="text-on-surface-variant dark:text-slate-500 text-sm text-center">
          © {new Date().getFullYear()} WorldCup Fan Planner. Educational fan planning tool—not an official FIFA site.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
